import { execute } from './execute';
import { ConsultaCatalogoArgs, ConsultaCatalogoResponse } from './interfaces/CatalogoService/ConsultaCatalogo';

const CatalogoService = {
  consultaCatalogo: ({ dispatch, path }: ConsultaCatalogoArgs) => {
    return execute({
      dispatch,
      method: 'get',
      route: `catalogos/legacy/${path}`,
      showNotificationError: true,
      showLoader: false,
    }) as Promise<ConsultaCatalogoResponse>;
  },
};

export default CatalogoService;
